import { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import store, { lendingLimitActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { LoanSummaryTable } from './components/LoanSummaryTable';

export const LoanSummaryModal = () => {
    const { isOpen, loans } = useSelector((state) => state.lendingLimit.lendingLimitLoanSummaryModal);

    const { dispatch } = store;

    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        formRow: { marginBottom: '0' },
        buttonContainer: {
            marginRight: '10px',
            marginLeft: '10px',
            textAlign: 'right',
        },
    };

    const _handleClose = () =>
        dispatch(
            lendingLimitActions.setLendingLoanLimitSummaryModal({
                lendingLimitLoanSummaryModal: { isOpen: false, loans: [] },
            })
        );

    useEffect(() => {
        if (!isOpen) return;
        // modal opened
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_handleClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex='-1'
                            role='dialog'
                            style={{ width: '1000px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>Loan History</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={_handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>

                                <div
                                    className='scrollable-content'
                                    style={{ margin: '10px' }}
                                >
                                    <LoanSummaryTable loans={loans} />
                                </div>

                                <div
                                    className='button-footer'
                                    style={styles.buttonContainer}
                                >
                                    <button
                                        type='button'
                                        className='button primary'
                                        data-dismiss='modal'
                                        onClick={_handleClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};
